import lindaVollmerAboutMe from './resources/img/linda_vollmer_teaching.jpg'
import erinWalerkoPortrait from './resources/img/erin_walerko_portrait.jpg'
// import lindaVollmerPortrait1 from './resources/img/fill_murray.jpg'
import lindaVollmerPortrait1 from './resources/img/linda_vollmer_portrait_final1.jpg'
import keyNecklaceImage from './resources/img/key-necklace-icon-512.png'


module.exports = {
  navbarData: [ {title: 'Home'}, {title: 'What We Do', subnav: ['COMMUNICATION COURSES', 'LEADERSHIP & SUPERVISION', 'PROFESSIONAL GROWTH & DEVELOPMENT']}, {title: 'Who We Are', subnav: ['Erin Walerko', 'Linda Vollmer']}, {title: "Previous Clients"}, {title: 'Get In Contact'} ],
  contactUsForm: {
    sectionHeaderForm: {
      title: "Contact Us",
      bodyText: ""
    },
    sectionHeaderComplete: {
      title: "Thanks For Getting In Contact",
      bodyText: "We Will Get Back to You Soon!"
    },
  },
  mainPage: {
    header: {
      navbar: [ {title: 'Home'}, {title: 'What We Do', subnav: ['COMMUNICATION COURSES', 'LEADERSHIP & SUPERVISION', 'PROFESSIONAL GROWTH & DEVELOPMENT']}, {title: 'Who We Are', subnav: ['Erin Walerko', 'Linda Vollmer']}, {title: "Previous Clients"}, {title: 'Get In Contact'} ]
    },
    whatWeDo: {
      sectionHeader: {
        title: "Training Tailored to meet all your organization's needs",
        bodyText: "Entertaining instruction designed to motivate as well as educate!  No travel expenses.  With locations in Virginia and Florida, we bring the training to you. Click the topic headings below for a brief course description, however all seminars are tailored to the current needs of your organization to deliver lasting positive changes at a price any company can afford."
      },
      sectionFooter: "",
      items: [
        {
          title: "COMMUNICATION COURSES",
          body: "KEY Training instructors are highly skilled in building strong organizations. We can help your team become more productive in a happier workplace through Team Building, Conflict Resolution, Myers Briggs Type Indicator, and Stress Management courses. Click here to see what else we offer to KEY your company for success.",
        },
        // {
        //   title: "FINANCIAL & COMPUTER COURSES",
        //   body: "Key Training has the expertise to help you and your employees reach your highest potential.  We can tailor courses in public speaking, effective communication, professional presentation techniques, and self assessment to name a few.  Check out other ways we can optimize you and your employees. ",
        // },
        {
          title: "LEADERSHIP & SUPERVISION",
          body: "These courses focus on excellence in leadership and management in both commercial and military organizations. Interviewing and Mentoring techniques as well as courses for increasing productivity are available. Click here for more topic ideas.",
        },
        {
          title: "PROFESSIONAL GROWTH & DEVELOPMENT",
          body: "Individual and organizational growth is essential for success. We provide seminars for both civilian and military organizations in transition. Let us help your employees develop plans for advancement.  KEY trainers are particularly experienced in transition of all types from corporate re-sizing to military separation and retirement.  Click here and allow us to smooth the path of change of all involved.",
        }
      ]
    },
    ourTeam: {
      sectionHeader: {
        title: "Our Team",
        bodyText: "KEY Training is a CCR registered Woman-Owned business that provides individually designed seminars for Corporate, Military, and Government Service Professionals."
      },
      items: [{
        name: "Linda Vollmer",
        link: "about/linda-vollmer",
        imgSrc: lindaVollmerPortrait1,
        imgAltText: "Portrait of Linda Vollmer",
        aboutText: "Linda brings a proven reputation for truly effective training in a challenging and ever-changing marketplace."
      },
      {
        name: "",
        link: "",
        imgSrc: keyNecklaceImage,
        imgAltText: "",
        aboutText: ""
      },
      {
        name: "Erin Walerko",
        link: "about/erin-walerko",
        imgSrc: erinWalerkoPortrait,
        imgAltText: "Portrait of Erin Walerko",
        aboutText: "Erin brings a proven reputation for truly effective training in a challenging and ever-changing marketplace."
      }]
    },
    previousClients: {
      sectionHeader: {
        title: "KEY Clients Include",
        bodyText: ""
      },
      sectionFooter: "Contact us for more references.",
      items: [{
        title: "Major Corporations",
        companies: [
          "Coca Cola Enterprises",
          "National Center for Housing Management",
          "Biomet Microfixation",
          "Small Business Administration",
          "Honeywell"]
      },
      {
        title: "Educational Institutions",
        companies: [
          "Virginia Commonwealth University",
          "Florida Community College, Jacksonville",
          "NJ School District",
          "Notre Dame ROTC"
        ]
      },
      {
        title: "Government & Military",
        companies: [
          "All Branches of the Military",
          "SPAWARS",
          "Department of Transportation",
          "Human Resource Services, Southeast",
          "Pro Bono Presenter Naval Transition Assistance Program"]
      },
      {
        title: "Speaking Engagements",
        companies: [
          "Professional Housing Management Assoc. (PHMA)",
          "International Hotel, Motel & Restaurant Assoc. (IHM&RA) Convention",
          "United Methodist Women’s Retreat",
          "BUMC Christian Singles Ministry",
          "National Day of Prayer"]
      },
      {
        title: "Health Care Organizations",
        companies: [
          "Surgical Care Affiliates",
          "Mayo Clinic",
          "Walter Reed Medical Center",
          "American College of Nurse Midwives",
          "Hospice"]
      }]
    },
  },

  aboutMe: {
    header: {
      navbar: [ {title: 'Home'}, {title: 'What We Do', subnav: ['COMMUNICATION COURSES', 'LEADERSHIP & SUPERVISION', 'PROFESSIONAL GROWTH & DEVELOPMENT']}, {title: 'Who We Are', subnav: ['Erin Walerko', 'Linda Vollmer']}, {title: "Previous Clients"}, {title: 'Get In Contact'} ]
    },
    erinWalerko: {
      name: "Erin Walerko",
      location: "Virginia",
      picture: erinWalerkoPortrait,
      areasOfExpertise: [
        "Certified Global Career Counselor, Facilitator and Train-the-Trainer",
        "Qualified Myers-Briggs Type Indicator Administrator",
        "Certified Relocation Professional"
      ],
      education: [
        "Undergraduate studies at St Mary’s College, Notre Dame.",
        "Public Relations degree from Indiana University.",
        "Master’s in Marketing and Human Relations from Oklahoma University."
      ],
      footNotes: [
        "Extensive experience in a wide variety of training topics, specializing in Team Building, Motivation, Communication, Transition, and Humorobics.",
        "Erin can design a seminar tailored to the training needs of any company."
      ]

    },
    lindaVollmer: {
      name: "Linda Vollmer",
      location: "Florida",
      picture: lindaVollmerAboutMe,
      areasOfExpertise: [
        "Certified Myers-Briggs Type Indicator Administrator",
        "Health Promotions Director",
        "Career Targeting & Transition Counselor",
        "Guest Speaker, Naval Transition Assistance Program",
        "Representative NE Florida Employer Support of the Guard and Reserve (ESGR)"
      ],
      education: [
        "Bachelors Degree Business Administration and Marketing from the University of Florida"
      ],
      footNotes: [
        "Professional national and international speaker with diverse and extensive experience specializing in Communication, Customer Service Skills, and Professional Presentation Techniques.",
        "Linda has a passion for enabling anyone to address a group of any size without anxiety!",
        "Combining humor and current market examples, she provides high-energy interactive seminars striving to find the perfect balance of increased productivity and quality of life in the workplace."
      ]

    }
  },

  coursesOffered: {
    header: {
      navbar: [ {title: 'Home'}, {title: 'What We Do', subnav: ['COMMUNICATION COURSES', 'LEADERSHIP & SUPERVISION', 'PROFESSIONAL GROWTH & DEVELOPMENT']}, {title: 'Who We Are', subnav: ['Erin Walerko', 'Linda Vollmer']}, {title: "Previous Clients"}, {title: 'Get In Contact'} ]
    },
    sectionHeader: {
      title: "Courses we offer",
    },
    courses: [
      {
        title: "CONDUCTING EFFECTIVE MEETINGS",
        description: "Make time together count! Learn basic meeting types, group focusing techniques, how to handle common meeting disputes and encourage productive contributions from all personality types.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "CONTEMPORARY NAVY WRITING",
        description: "Writing is a vital skill to success in the workplace! This writing class provides a thorough understanding and application of effective Navy writing. Covered, are the mechanics for correct Navy standards (content, syntax, and punctuation and grammar), as well as effective ways to present ideas in sentences and paragraphs. The course also addresses how to assess what readers need to know, effective proofreading and revision techniques and how to use preferred Navy standards in correspondence of all types.  Participants will get to practice what they learn in a fun and interactive way during the class.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "CUSTOMER SERVICE",
        description: "Identify internal and external customers and improve relationships with both in ways never before considered.  With multi-media being such a large part of today’s workplace, customer service approaches need to be equally varied.  Upon completion, participants will be able to apply new skills to effectively handle even the most difficult situations.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "EFFECTIVE PRESENTATIONS",
        description: "Many professionals are afraid of public speaking and/or making presentations. This 2-day course teaches participants outstanding techniques used for preparing and delivering professional presentations. Included will be structured speaking opportunities followed by feedback that focuses on both vocal and physical behaviors. Gain techniques for audience participation, time awareness and handling difficult questions",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "FACILITATION SKILLS",
        description: "The ability to effectively facilitate meetings, small and large groups, and training seminars is an essential skill for anyone in a position of leadership. Learn to prepare, handle logistics and manage challenging dynamics in all types of venues.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "INTERPERSONAL COMMUNICATION",
        description: "Applying the Myers Briggs Type Indicator, this seminar helps participants examine their unique communication styles, strengths, and preferences. It covers strategies for reversing tensions between colleagues, de-escalating interactions with angry customers, and focuses on developing positive, respectful relationships in the workplace.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "NAVAL CORRESPONDENCE",
        description: "Writing styles vary but should always reflect professionalism. Diminish re-writes and frustrations. Department of Navy prescribes uniform standards for the managing and preparing of proper correspondence for all situations. This course provides answers to questions regarding responsibilities and techniques as well as helpful resources for creating documents that are accurate and effective without being wordy or overly formal.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "TELEPHONE SKILLS",
        description: "Who has priority for your attention, the customer on the phone or standing before you? How important is tone? This course reminds participants of basic courtesies and reveals tips for handling timing, irate callers, and conversations that turn into conflicts.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "WRITING SKILLS WORKSHOP",
        description: "Having a strong competency in writing techniques can be paramount to success.  Learn key components of business writing, style, grammar, and punctuation. You will learn the techniques of writing in an effective manner to catch your reader’s attention and keep it!   No matter what type of documents, briefs, or letters that you draft, there are fundamental writing skills that will enhance your success.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      {
        title: "WRITING EFFECTIVE EVALUATION JUSTIFICATIONS AND AWARDS",
        description: "Many supervisors admit reluctance to write up awards for employees due to discomfort with justifications or difficulty capturing performance/achievements in writing. This class will help participants learn highly successful techniques for writing any type of evaluation, justification or award. The participants will have the opportunity to practice these techniques in class and see the developments in their writing skills.",
        category: "COMMUNICATION COURSES",
        url: "communication-courses"
      },
      // {
      //   title: "",
      //   description: "",
      //   category: "FINANCIAL & COMPUTER COURSES",
      //   url: "financial-computer-courses"
      // },
      // {
      //   title: "",
      //   description: "",
      //   category: "FINANCIAL & COMPUTER COURSES",
      //   url: "financial-computer-courses"
      // },
      // {
      //   title: "",
      //   description: "",
      //   category: "FINANCIAL & COMPUTER COURSES",
      //   url: "financial-computer-courses"
      // },
      // {
      //   title: "",
      //   description: "",
      //   category: "FINANCIAL & COMPUTER COURSES",
      //   url: "financial-computer-courses"
      // },
      // {
      //   title: "",
      //   description: "",
      //   category: "FINANCIAL & COMPUTER COURSES",
      //   url: "financial-computer-courses"
      // },
      {
        title: "CIVILIANS & MILITARY WORKING TOGETHER!",
        description: "Different goals, different perspectives, different styles of communication can make working together a challenge. This 8 hour interactive course addresses all types of issues including language, work schedule expectations and organizational priorities.  Conflict resolution skills are practiced that enable those who support and supervise the ones who serve to become bi-lingual!",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "INTERVIEWING TECHNIQUES",
        description: "Times, applicants and job descriptions change but the goal of interviewing remains the same; how to best determine if this person will be a fit for your team. Discover new ways of soliciting common goals and discovering individual potential in today's competitive marketplace.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "COMMUNICATION SKILLS FOR SUPERVIORS",
        description: "Communication is the key to success!  This class will focus on the importance of effective verbal and non-verbal communication and what your managerial style is saying to staff members.  Become aware of all the filters that affect everyone on the staff in both positive and negative ways.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "DEVELOPING EFFECTIVE PERFORMANCE APPRAISALS",
        description: "Performance Appraisals are designed to assist individuals in their career development and goal-setting objectives. This feedback is required for both the employee and supervisor. Learn how to write meaningful, measurable and accurate appraisals that will help you and your organization grow.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "EEO FOR SUPERVISORS",
        description: "Understanding and abiding by EEO regulations are paramount to any supervisor’s success.  Learn the laws, regulations, guidelines, and restrictions you need to know in your everyday role as supervisor.  Understand about dealing with grievances, complaints, and the resolution process.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "EXCELLENCE IN LEADERSHIP",
        description: "Increase your leadership abilities and help develop your staff to new heights of performance.  Learn how to better motivate your employees and build confidence in your own abilities.  This class will also focus on further developing your critical thinking skills and cover ALL the key issues involved in being an outstanding leader.  Not only will one learn the many facets of excellence in leadership, they will have the opportunity to demonstrate it with one another during the class to ensure they understand how to apply it.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "INTRODUCTION TO SUPERVISION",
        description: "This class is designed for staff in 1st-line supervisory positions. It will help define your supervisory role and provide techniques for effective leadership styles. The course covers effective communication using the Myers-Briggs Type Indicator, and a framework for managing work performance. Exercises include a variety of steps and elements to develop and grow supervisory skills.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "LEADERSHIP FOR MANAGERS AND SUPERVISORS",
        description: "Leadership is different than management, it is the ability to develop one’s team to new heights/skills/abilities. This course will assist managers and supervisors gain beneficial leadership techniques along with how and when to use them.  It will also cover the difference between management and leadership and how one can enhance the other.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "MENTORING",
        description: "Mentoring is an effective way to provide professional development and to enhance learning in the workplace.  The mentoring relationship is a special relationship built on trust, encouragement, and targeted development.  A Mentor is a teacher, coach, and advisor who provides guidance and opportunities for learning and professional growth opportunities for another employee.  Learn how to most effectively use a robust mentoring program and how much it can aid you in your professional development. There is a separate class for being either a mentor or mentoree if  requested",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "PREVENTION OF SEXUAL HARASSMENT FOR SUPERVISORS",
        description: "Supervisors are encouraged to take steps necessary to prevent sexual harassment from occurring and  clearly communicate to employees that sexual harassment will not be tolerated. They can do so by establishing an effective complaint or grievance process and taking immediate and appropriate action when an employee complains This session will cover the Employment Relations Act , employer’s responsibilities and steps for prevention and dealing with issues if they do occur. The greatest productivity occurs in a workplace environment of equality and respect.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "SUPERVISING EMPLOYEES WITH DISABILITIES",
        description: "Studies have shown employees with disabilities perform at the same or higher level than non-disabled workers in terms of productivity, attendance, and loyalty. With clear 2-way communication, capabilities and expectations unite to create a workforce where every member knows their value is appreciated and recognized.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "TEAM BUILDING",
        description: "Not a new concept!  Monitoring the pulse of morale is a critical management strategy. Learn innovative ways for providing feedback resources, sponsoring fresh events to encourage a spirit of unity as well as programs for individual development. It may not be a new concept, but there are new ways to create and measure work environment health.",
        category: "LEADERSHIP/SUPERVISION",
        url: "leadership-supervision"
      },
      {
        title: "CAREER DEVELOPMENT",
        description: "For busy government employees at all levels, it is easy to lose sight of career advancement when dealing with daily challenges. This class presents often overlooked opportunities and resources to provide job satisfaction and growth.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "CONFLICT MANAGEMENT/RESOLUTION",
        description: "Is your office productivity suffering because of conflicts between co-workers, supervisors, or departments? Learn how to communicate through emotional situations and address hostility. This course will provide resolution techniques specific to your daily challenges.  Discussion covers mediation, arbitration and one-on-one techniques for deescalation.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "CHANGE MANAGEMENT",
        description: "Change and stress go hand in hand.  Whether it is embraced or resisted determines the impact change will have on an individual or an organization.  Discover why most people are opposed to change and how to adopt a more constructive attitude to the inevitable. Learn how to understand and work effectively in the midst of change.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "MANAGING CULTURAL DIVERSITY",
        description: "Increase sensitivity to individual differences, appreciate the benefits of workplace diversity, and improve the quality of work relationships. The class covers managerial strategies for increasing awareness at all levels; cultural and ethnic differences, direct and indirect racism, gender equity, unconscious stereotyping and more.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "CSRS PRE-RETIREMENT PLANNING SEMINAR",
        description: "Civil Service Retirement System. This class is essential to understanding timing, annuities, TSP, Social Security, laws, regulations and benefits. Learn all aspects of retirement preparation and what you need to know regarding your retirement such as: Military service credit, disability retirement, survivor benefits, early retirement and computing benefits.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "FERS PRE-RETIREMENT PLANNING SEMINAR",
        description: "Annuities, Social Security, TSP, Disability classifications, Early Retirements, Buy-Outs, Phased Retirements, Formulas and Beneficiaries. Get proactive! There are many aspects, financial and psychological to retirement preparation for the Federal Employee. Let our expert prepare you for the next exciting chapter of life!",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "NAVIGATING A MULTI-GENERATIONAL WORKFORCE",
        description: "In the U.S. today, many people readily identify themselves as Millenials, Xers or Baby Boomers. You can find yourself working with, supervising or being supervised by a mixture of generations. Learn why this is a huge value to your organization. Embrace different perspectives and approaches. Experience should be respected, but a company that creates an environment where all ideas are encouraged maintains their edge in an ever-changing marketplace",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "PREVENTION OF WORKPLACE VIOLENCE",
        description: "How can an individual employee recognize a potentially dangerous situation? What steps should be taken to prevent violence from occurring without encouraging paranoia? What is required to maintain a safe and healthy work environment and where does the responsibility lie?  This course will cover procedures and local resources for both prevention and response.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "PROBLEM SOLVING & DECISION MAKING",
        description: "The average adult in the U.S. makes about 35,000 decisions each day. Most are simple ones. Where will I sit, what will I have to eat,  am I thirsty, should I call to let them know I'm late. Once you reach that office, bigger choices have to be made.  Learn how to approach the process in a methodical and proactive manner and become far more effective in your position. Prioritizing, delegating and time- management are just a few tools covered. Highly successful leaders are often noted for their outstanding problem-solving and decision-making skills. ",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "STRESS MANAGEMENT",
        description: "Stress impacts health, quality of life and productivity.  Learn new ways to identify and overcome internal and external stressors. Gain vital techniques to reduce the effects of stress at work and at home. Regain control over daily challenges, and understand and apply stress reducing psychological habits for positive mental health.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "TIME MANAGEMENT",
        description: "Do you feel you are always busy but rarely satisfied with the results? Learn to prioritize, develop action plans, minimize distractions and get across that finish line! You can work efficiently and effectively. Your time matters! Let us show you how to make it count.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      },
      {
        title: "TECHNOLOGY AND ETIQUETTE IN TODAY'S WORKPLACE",
        description: "Without electronics the world as we now know it would come to a shocking standstill!  But what does having that muted cell phone on the table during a business lunch actually say to our client? How do we manage one-way conversations while in the presence of others? Learn how to maintain professionalism and courtesy while keeping technology working for us.",
        category: "PROFESSIONAL GROWTH & DEVELOPMENT",
        url: "professional-growth-development"
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/data.js